"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _PopoverMenu = _interopRequireDefault(require("./PopoverMenu"));

var _Anchor = _interopRequireDefault(require("../general/Anchor"));

var _popsOver = _interopRequireDefault(require("../../util/behaviors/popsOver"));

var _underscore = _interopRequireDefault(require("underscore"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PropUtils = require("../../util/PropUtils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var PopoverMenuBase = _PopoverMenu.default.Base;

var PopoverNavMenuBase = /*#__PURE__*/function (_PopoverMenuBase) {
  (0, _inherits2.default)(PopoverNavMenuBase, _PopoverMenuBase);

  var _super = _createSuper(PopoverNavMenuBase);

  function PopoverNavMenuBase() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, PopoverNavMenuBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getIcon", function (item) {
      if (item.iconSrc) {
        return /*#__PURE__*/_react.default.createElement("img", {
          src: item.iconSrc,
          className: "icon nav-menu__icon"
        });
      } else {
        var iconClassName = (0, _PropUtils.getIconClassName)(item);

        if (iconClassName) {
          return /*#__PURE__*/_react.default.createElement("span", {
            className: (0, _classnames.default)("icon", "nav-menu__icon", iconClassName)
          });
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_anyIcons", function () {
      var _context2;

      return (0, _reduce.default)(_context2 = _this.props.items).call(_context2, function (result, item) {
        if (result || (0, _PropUtils.getIconClassName)(item)) {
          return true;
        } else {
          return false;
        }
      }, false);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderItem", function (item, handleClick, index) {
      var _context3;

      var url = item.url,
          _item$href = item.href,
          href = _item$href === void 0 ? url : _item$href,
          label = item.label,
          target = item.target,
          _item$dataId = item["data-id"],
          dataId = _item$dataId === void 0 ? (0, _concat.default)(_context3 = "".concat(_this.props["data-id"], "-link-")).call(_context3, label ? label.toString() : index) : _item$dataId;
      return /*#__PURE__*/_react.default.createElement(_Anchor.default, {
        "data-id": dataId,
        href: href,
        key: label,
        className: (0, _classnames.default)("nav-menu__link", {
          "nav-menu__link--w-icon": _this._anyIcons()
        }),
        onClick: handleClick,
        target: target
      }, _this._getIcon(item), label);
    });
    return _this;
  }

  return PopoverNavMenuBase;
}(PopoverMenuBase);

(0, _defineProperty2.default)(PopoverNavMenuBase, "defaultProps", _underscore.default.extend(PopoverMenuBase.defaultProps, {
  "data-id": "popover-nav-menu"
}));
var PopoverNavMenu = (0, _popsOver.default)(PopoverNavMenuBase);
module.exports = PopoverNavMenu;